import { render, staticRenderFns } from "./ItemDialogo.vue?vue&type=template&id=4000c0dc&scoped=true&"
import script from "./ItemDialogo.vue?vue&type=script&lang=ts&"
export * from "./ItemDialogo.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDialogo.vue?vue&type=style&index=0&id=4000c0dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4000c0dc",
  null
  
)

export default component.exports